import { string, bool } from 'prop-types';
import PaperClip from 'imagesUwKluis/svg/paperclip.svg';
import Flex from '../../shared/layouts/Flex';

const svgStyling = (theme) => ({
  fill: theme?.colors?.primary || 'black',
});

const SubjectWithAttachment = ({ subject, hasAttachment }) => (
  <Flex justifyContent="center" alignItems="center" width="100%" mr="3xl">
    <Flex flexGrow={1} flexBasis="100%">
      {subject}
    </Flex>
    {hasAttachment && (
      <PaperClip height="18px" css={svgStyling} />
    )}
  </Flex>
);

SubjectWithAttachment.propTypes = {
  subject: string.isRequired,
  hasAttachment: bool,
};

SubjectWithAttachment.defaultProps = {
  hasAttachment: false,
};

export default SubjectWithAttachment;
